import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const FeatureFlagContext = createContext({});

export function FeatureFlagProvider({ children, flags }) {
  const [enabled, setEnabled] = useState(() => flags || {});

  useEffect(() => {
    if (flags) {
      setEnabled(flags);
      return undefined;
    }
    let live = true;
    supabase.auth.getSession()
      .then(async ({ data }) => {
        if (!live || !data || !data.session) return null;
        const result = await supabase.rpc('enabled_feature_flags');
        if (!live || result.error || !Array.isArray(result.data)) return null;
        const next = {};
        result.data.forEach((key) => { next[key] = true; });
        setEnabled(next);
        return null;
      })
      .catch(() => {});
    return () => { live = false; };
  }, [flags]);

  return (
    <FeatureFlagContext.Provider value={enabled}>
      {children}
    </FeatureFlagContext.Provider>
  );
}

export function useFeatureFlag(key) {
  const flags = useContext(FeatureFlagContext);
  return flags[key] === true;
}

export function FeatureGate({ flag, children }) {
  const on = useFeatureFlag(flag);
  if (!on) return null;
  return children;
}
